export function isMobileOrTablet() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}

export function objectToGetParams(object) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return params.length > 0 ? `?${params.join("&")}` : "";
}

export function whatsappLink(url, { title, separator }) {
  return (
    "https://" +
    (isMobileOrTablet() ? "api" : "web") +
    ".whatsapp.com/send" +
    objectToGetParams({
      text: title ? title + separator + url : url,
    })
  );
}
export function emailLink(url, { subject, body, separator }) {
  return (
    "mailto:" +
    objectToGetParams({ subject, body: body ? body + separator + url : url })
  );
}

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const generateSixDigitCode = () =>
  Math.floor(Math.random() * 900000) + 100000;
export const toAlphanumeric = (num) => {
  if (num < 100000 || num > 999999) {
    throw new Error("Input must be a six-digit number.");
  }
  return num.toString(26).toUpperCase().padStart(6, "0"); // Ensure it's at least 6 chars long
};

// Convert Alphanumeric to Six-Digit Number
export const toSixDigitNumber = (str) => {
  if (str.length !== 6) {
    throw new Error("Input must be a six-character alphanumeric string.");
  }
  const num = parseInt(str, 26);
  if (isNaN(num) || num < 100000 || num > 999999) {
    throw new Error("Converted number is not a valid six-digit number.");
  }
  return num;
};
 export const refIcon = (ref) => {
  if (!ref) return "🔗";
  if (ref.includes("instagram")) return "📸";
  if (ref.includes("google")) return "🔍";
  if (ref.includes("facebook")) return "👥";
  if (ref.includes("t.co")) return "🐦";
  if (ref.includes("wa.me")) return "💬";
  if (ref.includes("youtube")) return "▶️";
  return "🔗";
};



export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toISOString().replace("T", " ").slice(0, 16);
  } catch {
    return d;
  }
};

